import { atom } from "recoil";

const salesAtom = atom({
	key: "salesAtom",
	default: [],
});

export default salesAtom;
